// extracted by mini-css-extract-plugin
export default {"wrapper":"text-collapse_wrapper__Y432c","content":"text-collapse_content__gExAV","toggleButton":"text-collapse_toggleButton__l5F+0"};